import { render, staticRenderFns } from "./modalComisionVendedor.vue?vue&type=template&id=4dee3e7c&"
import script from "./modalComisionVendedor.vue?vue&type=script&lang=js&"
export * from "./modalComisionVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports